export ts_runthetrickstrat from '../../images/promo/ts_runthetrickstrat.jpg';
export ts_social from '../../images/promo/ts_social.jpg';
export gears_procircuit from '../../images/promo/ts_gears.jpg';
export gears_gowrostermania from '../../images/promo/ts_gowrostermania.jpg';
export lb_dreamhack from '../../images/promo/ts_lb_dreamhack.jpg';
export ts_rs6 from '../../images/promo/ts_rs6.jpg';



// WEBPACK FOOTER //
// ./src/app/utils/promos/promo_paths.jsx